import React from "react";

import { BorderedBlock } from "../../../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { CheckboxField } from "../../../../../../features/forms/fields/checkbox-field/checkbox-field.component";

import { CbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control.props";

export const CbTemplateControlHasVendorCommitment = (props: CbTemplateControlProps) => (
  <BorderedBlock>
    <CheckboxField
      form={props.form}
      label="Has Vendor commitment"
      name="hasVendorCommitment"
      userPermissions={props.userPermissions}
    />
  </BorderedBlock>
);
